<template>
    <div class="filters">
        <v-layout row wrap>
            <v-flex md3>
                <div class="filters__field">
                    <v-layout column>
                        <div>
                            <span class="label">Recorder ID</span>
                        </div>
                        <v-text-field
                            label="Recorder Id"
                            placeholder="Recorder id"
                            v-model="filters.name"
                            outline
                            single-line
                        ></v-text-field>
                    </v-layout>
                </div>
            </v-flex>
            <v-flex md3 v-if="hasAllRoles(['OrganizationView']) && !activeImpersonate">
                <div class="filters__field">
                    <v-layout column>
                        <div>
                            <span class="label">Organization</span>
                        </div>
                        <organization-autocomplete
                            v-model="filters.organization"
                            :disabled="isFleet"
                        ></organization-autocomplete>
                    </v-layout>
                </div>
            </v-flex>
            <v-flex md3 v-if="hasAllRoles(['FleetView'])">
                <div class="filters__field">
                    <v-layout column>
                        <div>
                            <span class="label">Fleet</span>
                        </div>
                        <fleet-autocomplete
                            v-model="filters.fleet"
                            :organization="filters.organization"
                            :disabled="isFleet"
                        ></fleet-autocomplete>
                    </v-layout>
                </div>
            </v-flex>
            <v-flex md3>
                <div class="filters__field">
                    <v-layout column>
                        <div>
                            <span class="label">Device model</span>
                        </div>
                        <v-select
                            v-model="filters.deviceModelId"
                            :items="getDeviceModels"
                            label="Select a device model"
                            item-text="key"
                            item-value="id"
                            outline
                            clearable
                            single-line
                        ></v-select>
                    </v-layout>
                </div>
            </v-flex>
            <v-flex md3>
                <div class="filters__field">
                    <v-layout column>
                        <div>
                            <span class="label">Device protocol</span>
                        </div>
                        <v-select
                            v-model="filters.deviceProtocolId"
                            :items="getDeviceProtocols"
                            label="Select a device protocol"
                            item-text="key"
                            item-value="id"
                            clearable
                            outline
                            single-line
                        ></v-select>
                    </v-layout>
                </div>
            </v-flex>
            <v-flex md3>
                <div class="filters__field">
                    <v-layout column>
                        <div>
                            <span class="label">Sim card</span>
                        </div>
                        <v-text-field
                            label="Sim Card"
                            placeholder="Sim Card"
                            v-model="filters.simCard"
                            outline
                            single-line
                        ></v-text-field>
                    </v-layout>
                </div>
            </v-flex>
            <v-flex md3 v-if="hasAllRoles(['VehicleView'])">
                <div class="filters__field">
                    <v-layout column>
                        <div>
                            <span class="label">Vehicle</span>
                        </div>
                        <vehicle-autocomplete
                            v-model="filters.vehicle"
                            disable-add
                        ></vehicle-autocomplete>
                    </v-layout>
                </div>
            </v-flex>
        </v-layout>
        <v-layout row>
            <v-flex md3>
                <div class="filters__field">
                    <v-layout column>
                        <v-flex xs6 align-self-center>
                            <div class="label text-xs-right">
                                <span class="text-xs-right">Enabled</span>
                            </div>
                        </v-flex>
                        <v-flex xs6 align-self-center>
                            <v-checkbox
                                v-model="filters.enabled"
                                class="checkbox"
                            ></v-checkbox>
                        </v-flex>
                    </v-layout>
                </div>
            </v-flex>
            <v-flex md3>
                <div class="filters__field">
                    <v-layout column>
                        <v-flex xs6 align-self-center>
                            <div class="label text-xs-right">
                                <span class="text-xs-right">Never reporter</span>
                            </div>
                        </v-flex>
                        <v-flex xs6 align-self-center>
                            <v-checkbox
                                v-model="filters.neverReporter"
                                class="checkbox"
                            ></v-checkbox>
                        </v-flex>
                    </v-layout>
                </div>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
import OrganizationAutocomplete from '@/views/Organizations/components/OrganizationAutocomplete'
import FleetAutocomplete from '@/views/Fleets/components/FleetAutocomplete'
import VehicleAutocomplete from '@/views/Vehicles/components/VehicleAutocomplete'
import { mapGetters } from 'vuex'

export default {
    name: 'DevicesFilters',
    components: {
        FleetAutocomplete,
        OrganizationAutocomplete,
        VehicleAutocomplete
    },
    props: {
        filters: {
            type: Object,
            required: true
        },
        isFleet: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        ...mapGetters('dictionaryModule', [
            'getDeviceModels',
            'getDeviceProtocols'
        ]),
        ...mapGetters('authModule', [
            'getActiveOrganization',
            'getDefaultOrganization'
        ]),
        activeImpersonate () {
            return this.getActiveOrganization !== this.getDefaultOrganization
        }
    },
    watch: {
        'filters.organization': function (newVal, oldVal) {
            this.filters.fleet = null
        },
        deep: true
    }
}
</script>

<style lang="scss" scoped>
.filters {
    .checkbox {
        margin-left: 5px !important;

        ::v-deep .v-input__slot {
            min-height: 0 !important;
            margin-top:12px;
        }
    }
}
</style>
